<template>
  <div class="configuration-wizard mx-auto max-w-3xl">
    <transition
      name="slide-left"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConfigurationWizard',

  computed: {
    ...mapGetters(['hasFinishedWizard']),
  },

  created() {
    if (this.hasFinishedWizard) {
      this.$router.push({ name: 'event.track.search' });
    }
  },


};

</script>
